import React from "react";
import Fieldset from "../../common/Fieldset";
import TextAreaInput from "../../common/TextAreaInput";
import PropTypes from "prop-types";


const OpmerkingFormItem = (props) => {
    const { model, onChange, errors } = props;
    return (
        <Fieldset title="Opmerkingen">
            <TextAreaInput
                name="opmerking"
                label="Opmerking"
                onChange={onChange}
                value={model.opmerking}
                validationMessage={errors ? errors['opmerking'] : ""}
            />
        </Fieldset>
    );
};

OpmerkingFormItem.propTypes = {
    model: PropTypes.object,
    onChange: PropTypes.func,
    errors: PropTypes.array
};

export default OpmerkingFormItem;